import { useUserStore } from '../../context';

import { CompanyModel } from './types';

export const useCurrentCompany = (): CompanyModel | null =>
  useUserStore().selectedCompany;
